import { z } from "zod";

// Module « tenants » : établissements (organisations, clients, sites…) et
// rattachement des comptes à un établissement avec un rôle. Sert de base au
// portail scopé : un utilisateur non-admin ne voit que ses établissements.

export type TenantUserRole = "tenant_owner" | "tenant_staff";

export interface Tenant {
  id: string;
  name: string;
  timezone: string;
  /** Réglages libres propres au projet (JSON sérialisé) ou null. */
  metadataJson: string | null;
  createdAt: number | string;
}

export interface TenantLink {
  tenantId: string;
  name: string;
  role: TenantUserRole;
}

export interface TenantMember {
  userId: string;
  email: string;
  name: string;
  role: TenantUserRole;
}

export const tenantUserRoleSchema = z.enum(["tenant_owner", "tenant_staff"]);

export const createTenantSchema = z.object({
  name: z.string().min(1).max(120),
  timezone: z.string().min(1).default("America/Montreal"),
  metadataJson: z.string().nullable().optional(),
});
export type CreateTenantInput = z.infer<typeof createTenantSchema>;

export const updateTenantSchema = createTenantSchema.partial();
export type UpdateTenantInput = z.infer<typeof updateTenantSchema>;

export const assignMemberSchema = z.object({
  userId: z.string().min(1),
  role: tenantUserRoleSchema,
});
export type AssignMemberInput = z.infer<typeof assignMemberSchema>;

export const TENANT_ROLE_LABELS: Record<TenantUserRole, string> = {
  tenant_owner: "Responsable",
  tenant_staff: "Membre",
};
